module.exports = __webpack_public_path__ + "close.svg";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/ui/qr-popup/assets/close.svg
// module id = 1112
// module chunks = 10